/* Main scripts
========================================================================== */

/* Alto completo para ajustar en dispositivos moviles */
document.getElementById('page').style.height = window.innerHeight + 'px';
window.addEventListener('resize', div_page_height);
function div_page_height() { document.getElementById('page').style.height = window.innerHeight + 'px'; }

/* CAMBIO IMG LOGO HOVER */
if (document.getElementById('logotipo')) {
	document.getElementById('logotipo').addEventListener('mouseover', mouse_hover_logo);
	document.getElementById('logotipo').addEventListener('mouseleave', mouse_leave_logo);
	function mouse_hover_logo() { this.src = BASE_URL + '/wp-content/themes/replika/assets/images/logo-k.svg'; }
	function mouse_leave_logo() { this.src = BASE_URL + '/wp-content/themes/replika/assets/images/logo.svg'; }
}

/* BTN FOOTER MENU */
document.getElementById('footer-btn-menu').addEventListener('click', mostrar_menu_footer);
function mostrar_menu_footer() {
	document.getElementById('colophon').classList.toggle('abierto');
}

/* Page profesores btn breve descripcion */
if (document.querySelectorAll('.btn-descripcion-breve')[0]) {
	let btns = document.querySelectorAll('.btn-descripcion-breve');
	for (let i = 0; i < btns.length; i++) {
		btns[i].addEventListener('click', function () {
			console.log('hola')
			this.parentElement.parentElement.classList.toggle("mostrar-breve-descripcion");
		});
	}
}

if (document.getElementById('btn-descripcion-breve')) {
	document.getElementById('btn-descripcion-breve').addEventListener('click', function () {
		this.parentElement.parentElement.classList.toggle("mostrar-breve-descripcion");
	});
}

if (window.location.pathname.indexOf('/evento/') !== -1) {
	let en_que_ancho_quitamos_columna_derecha = 1100;
	if (window.innerWidth <= en_que_ancho_quitamos_columna_derecha) {
		document.getElementById('col-izq').classList.add('ancho-total')
		document.getElementById('col-drch').classList.add('ancho-total')
		let clon = document.getElementById('col-drch').cloneNode(true);
		document.getElementById('col-drch').remove();
		document.getElementById('contenedor-movil-columna-derecha').appendChild(clon);
	}
}

if (jQuery('.swiper-container').length) {
	new Swiper('.swiper-container', {
		slidesPerView: 'auto',
		spaceBetween: 0,
		loop: true,
		speed: 20000,
		autoplay: {
			delay: 0,
			disableOnInteraction: false,
		},
	});
}


/* Formacion 2024 */
if (jQuery('.list-accordeon__block').length) {
	jQuery('.list-accordeon__title').unbind().on('click', function(e) {
		e.preventDefault();

		var $this = jQuery(this);

		$this.parent().toggleClass('active');
		$this.toggleClass('list-accordeon__title--active');
		$this.parent().find('.list-accordeon__content').first().slideToggle();

		return false;
	});

	jQuery('.list-accordeon__subtitle').unbind().on('click', function(e) {
		e.preventDefault();

		var $this = jQuery(this);

		$this.parent().toggleClass('active');
		$this.toggleClass('list-accordeon__title--active');
		$this.parent().find('.list-accordeon__content').first().slideToggle();

		return false;
	});
}


/* Scroll to */
if (jQuery('.go-to-anchor').length) {
	jQuery('.go-to-anchor').unbind().on('click', function(e) {
		e.preventDefault();
		goToScroll(this);
	});
}


if (window.location.hash) {
	var hash = window.location.hash.substring(1);
	jQuery('html, body').animate({
		scrollTop: jQuery('#'+hash).offset().top
	}, 800, function(){
		window.location.hash = hash;
	});
}


if ( jQuery('#contenedor-muestras').length ) {
	let $grid = jQuery('#contenedor-muestras').masonry({
		// options
		itemSelector: '#contenedor-muestras .post-muestra',
		percentPosition: true,
	});

	// layout Masonry after each image loads
	$grid.imagesLoaded().progress( function() {
		$grid.masonry();
	});  
  
}


var goToScroll = function(link) {
	if (link.hash !== "") {
		event.preventDefault();

		// Store hash
		var hash = link.hash;
		gentlyScrollTo(jQuery(hash), hash);
	}
}


var gentlyScrollTo = function($el, hash) {
	if($el.length) {
		jQuery('html, body').animate({
			scrollTop: $el.offset().top
		}, 800, function(){
			window.location.hash = hash;
		});
	}
}

document.addEventListener('DOMContentLoaded', function () {
    const toggler = document.querySelector('.navbar-toggler');
    const navCollapse = document.querySelector('#navbarNav');

    toggler.addEventListener('click', function () {
        this.classList.toggle('active');
    });

	const $buttonClose = document.querySelector('.close-navbar-menu');

	//open search
	$buttonClose.addEventListener('click', function (e) {
		e.preventDefault();
		console.log('entro');
		toggler.click();
		return false
	});
});


if ( jQuery('#open-finder').length ) {
	let $button_search = jQuery('#open-finder, .search-block__close');
	let $search = jQuery('#header-finder');

	//open search
	$button_search.on('click',function (e) {
		e.preventDefault();

		if ( jQuery('.header .hamburger').hasClass('is-active') ) {
			jQuery('.header .hamburger').click();
		 }
		$button_search.toggleClass('is-active');
		$search.slideToggle('fast'); 
		return false
	});
}